import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabbookingpune() {



  const cardData =
  {
    keyword: 'Outstation Cab Booking Pune',
    heading: 'Sai Trupti Cabs: Outstation Cab Booking Pune',
    headingDescription: 'Sai Trupti Cabs offers convenient and efficient out-station cab booking from Pune, designed to make your long-distance journeys smooth and stress-free. Our fleet of well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles are all equipped with clean interiors and ample luggage space. Every trip is managed by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving throughout your ride. With transparent one-way or round-trip fares, flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your out-station travel from Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the proud symbol of Pune’s Maratha heritage — once the seat of the mighty Peshwas. Built in 1732 by Bajirao I, this grand fort once housed royal courtyards, intricate teak pillars, fountains, and murals depicting scenes from the Mahabharata. Though much of it was destroyed by fire in 1828, its majestic gates and stone walls still echo the city’s golden era. The evening light-and-sound show narrates tales of bravery, politics, and romance that shaped Maratha history. Walking through its ancient arches, one can almost hear the voices of valor and legacy that define Pune’s soul."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a monument of peace, resilience, and patriotism. Built in 1892 by Sultan Aga Khan III, this graceful mansion became a part of India’s freedom struggle when Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Surrounded by lush gardens and Italian arches, the palace now serves as a museum preserving rare photographs, letters, and personal belongings of Gandhi. The tranquil ambiance invites visitors to reflect on India’s journey toward independence. Aga Khan Palace is not just an architectural gem but a shrine of history and sacrifice in Pune’s heart."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill about 30 km from Pune, Sinhagad Fort offers panoramic views of the Sahyadri ranges and the surrounding valleys. Once known as Kondhana, it witnessed the legendary battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors can trek to the fort’s summit, explore ancient ruins, and savor traditional snacks like pithla-bhakri from local stalls. The fort’s weathered walls still whisper tales of valor, loyalty, and Maratha pride. Whether for trekking, photography, or simply breathing in the mountain air, Sinhagad embodies Pune’s heroic and natural charm."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine carved out of basalt stone and dedicated to Lord Shiva. Hidden amidst the city’s bustle, this ancient temple is an oasis of calm and spirituality. Its circular Nandi pavilion, carved pillars, and echoing sanctum display exquisite craftsmanship from the Rashtrakuta era. The dimly lit interiors and rhythmic chants create an atmosphere that transcends time. As you step into the courtyard shaded by old banyan trees, the blend of faith and history feels almost tangible. Pataleshwar reminds visitors that Pune’s spiritual roots run deep beneath its modern skin."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, rising gracefully over Pune, combines scenic beauty with spiritual heritage. The temple complex at the summit — dedicated to Lord Shiva and Goddess Parvati — was built by the Peshwas and remains one of the city’s oldest landmarks. The climb of 108 stone steps rewards visitors with breathtaking views of the entire cityscape. Inside the temple, the air hums with devotion, while the surrounding breeze carries the aroma of incense. As the sun sets, the view from Parvati transforms into a golden panorama of old and new Pune. It’s a place where serenity meets history."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure chest of India’s artistic and cultural legacy. Curated by Dr. Dinkar Kelkar, it houses over 20,000 artifacts collected from across the country — from musical instruments and sculptures to jewelry, weapons, and handcrafted ornaments. The highlight is the recreated 'Mastani Mahal,' reflecting the elegance of Bajirao and Mastani’s era. Each artifact tells a story of creativity, craftsmanship, and everyday life in bygone centuries. For art lovers, it’s a journey through India’s soul; for Pune, it’s a proud reminder of its cultural depth."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for wellness, peace, and self-discovery. Spread over lush 28 acres, the resort features marble pathways, serene gardens, and modern meditation spaces surrounded by bamboo groves. Visitors from around the world come here to learn dynamic meditation and holistic healing practices. The Zen-like atmosphere and the fusion of nature with modern architecture make it a spiritual haven in the middle of an urban jungle. Whether for relaxation or transformation, Osho Ashram radiates calmness and international spiritual energy."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located just a short drive from Pune, is a beloved picnic and sunset spot surrounded by rolling hills. Built on the Mutha River, it is the city’s primary water source and a weekend retreat for locals. The shimmering water against the Sahyadri backdrop creates postcard-perfect views, especially during monsoon when the skies turn dramatic. Visitors enjoy roadside snacks, boating, and walks along the embankments. The cool breeze, golden sunsets, and reflection of clouds make it an ideal escape. Khadakwasla perfectly captures Pune’s balance of nature and modernity."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pu La Deshpande Udyan, also known as the Pune-Okayama Friendship Garden, is a symbol of Indo-Japanese harmony and aesthetic beauty. Modeled after Japan’s famous Korakuen Garden, it features landscaped lawns, small bridges, flowing streams, and stone paths amid lush greenery. Named after Marathi writer Pu La Deshpande, the garden offers peace and beauty in the middle of the city. Visitors enjoy serene walks, photography, and the tranquil charm of nature’s balance. It’s a perfect place to relax, reflect, and admire Pune’s cultural openness and ecological spirit."
  },
  {
    "title": "Dagadusheth Halwai Ganpati Temple",
    "description": "The Dagadusheth Halwai Ganpati Temple is one of Pune’s most sacred landmarks, attracting thousands of devotees daily. The temple’s magnificent Ganesha idol, adorned with gold and flowers, exudes grace and positivity. Founded more than a century ago by the sweet maker Dagadusheth Halwai, it has grown into a spiritual and cultural hub for Punekars. During Ganesh Chaturthi, the temple transforms into a dazzling sea of lights, music, and devotion. The rhythmic aarti and fragrance of incense fill the air, creating a divine atmosphere that defines the essence of Pune’s faith and festivity."
  }
],



"services": [
  {
    "name": "Outstation Cab Booking Pune",
    "description": "Book reliable outstation cabs from Pune for hassle-free travel. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars with experienced drivers, flexible pickup/drop points, and transparent pricing. Perfect for family trips, weekend getaways, or corporate journeys."
  },
  {
    "name": "Pune Outstation Cab Booking",
    "description": "Hire an outstation cab from Pune for safe and comfortable long-distance travel. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families."
  },
  {
    "name": "Outstation Taxi Booking Pune",
    "description": "Book an outstation taxi from Pune for stress-free travel. One-way or round-trip options with transparent fares and professional drivers ensure a smooth journey across cities and states."
  },
  {
    "name": "Outstation Car Hire Pune",
    "description": "Rent a car for outstation travel from Pune with personalized comfort and convenience. Choose from AC/non-AC Sedans, SUVs, and luxury vehicles, and enjoy professional drivers, luggage assistance, and flexible routes."
  },
  {
    "name": "AC Outstation Cab Pune",
    "description": "Travel in comfort with AC outstation cabs from Pune. Clean, air-conditioned vehicles, skilled drivers, and flexible pickup points ensure a relaxed and safe journey for families, couples, or solo travelers."
  },
  {
    "name": "Non AC Outstation Cab Pune",
    "description": "Affordable non-AC outstation cab service from Pune for budget-conscious travelers. Reliable drivers, well-maintained vehicles, and flexible pickup/drop points ensure safe and economical travel."
  },
  {
    "name": "Luxury Outstation Cab Pune",
    "description": "Travel in style with luxury outstation cabs from Pune. Premium interiors, AC comfort, and professional chauffeurs make it ideal for VIP guests, executives, or special occasions seeking comfort and prestige."
  },
  {
    "name": "Innova Outstation Cab Pune",
    "description": "Book spacious Innova outstation cabs from Pune. AC comfort, ample legroom, luggage space, and experienced drivers make it perfect for families, groups, or corporate trips for smooth long-distance travel."
  },
  {
    "name": "Ertiga Outstation Cab Pune",
    "description": "Affordable and convenient Ertiga outstation cabs from Pune. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure safe and enjoyable group travel."
  },
  {
    "name": "Affordable Outstation Cab Pune",
    "description": "Pocket-friendly outstation cab services from Pune with transparent fares, AC/non-AC options, and professional drivers. Flexible timings and easy booking make it ideal for solo travelers, students, and small families."
  },
  {
    "name": "Pune One Way Outstation Cab",
    "description": "Book one-way outstation cabs from Pune at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it perfect for travelers without return plans."
  },
  {
    "name": "Pune Drop Outstation Cab",
    "description": "One-way drop outstation cab service from Pune with AC/non-AC options, flexible timings, and professional drivers. Ideal for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Outstation Cab Pune",
    "description": "Premium corporate outstation cab hire from Pune with executive vehicles, professional chauffeurs, and flexible schedules. Perfect for business meetings, conferences, client visits, and corporate events."
  },
  {
    "name": "Wedding Outstation Cab Pune",
    "description": "Elegant outstation cab service from Pune for weddings with luxury interiors, AC comfort, professional drivers, and on-time pickups. Suitable for bride/groom transfers, guest transport, and event logistics."
  },
  {
    "name": "Best Outstation Cab Booking Pune",
    "description": "Experience the best outstation cab service from Pune with reliable vehicles, professional drivers, flexible bookings, and comfortable travel for families, groups, corporate travelers, and special occasions."
  }
],
"tableData": [
  ["Outstation Cab Booking Pune", "Pune Outstation Cab Booking"],
  ["Outstation Taxi Booking Pune", "Outstation Car Hire Pune"],
  ["AC Outstation Cab Pune", "Non AC Outstation Cab Pune"],
  ["Luxury Outstation Cab Pune", "Innova Outstation Cab Pune"],
  ["Ertiga Outstation Cab Pune", "Affordable Outstation Cab Pune"],
  ["Pune One Way Outstation Cab", "Pune Drop Outstation Cab"],
  ["Corporate Outstation Cab Pune", "Wedding Outstation Cab Pune"],
  ["Online Outstation Cab Booking Pune", "Best Outstation Cab Booking Pune"]
],

"whychoose": [
  {
    "WhyChooseheading": "Outstation Cab Booking from Pune",
    "WhyChoosedescription": "Sai Trupti Cabs offers convenient and reliable outstation cab services starting from Pune — perfect for family trips, business journeys, or leisure getaways."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "We provide clear and affordable fares for your outstation travel from Pune — no hidden costs, no surprise charges, and full value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from sedans, SUVs, premium cars, and even multi‑seaters based on your group size, comfort preferences, and budget for your Pune‑based outstation route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with long‑distance routes starting from Pune, ensuring safe, smooth and timely journeys."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune — airport, railway station, home, or office — and drop‑offs at your chosen destination outside the city."
  },
  {
    "WhyChooseheading": "Clean & Well‑Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains a fleet of clean, sanitized, and regularly serviced vehicles to ensure a comfortable and reliable outstation travel experience from Pune."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer‑support team is available 24/7 to help you with your outstation cab booking, route planning, and any travel queries originating from Pune."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your outstation cab from Pune easily via call, WhatsApp, or our website — get instant confirmation and enjoy a smooth, stress‑free journey."
  }
]


































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer outstation cab services from Pune?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable outstation cab services from Pune to destinations across Maharashtra and nearby states.',
  },
  {
    question: 'How can I book an outstation cab from Pune?',
    answer: 'You can book your outstation cab from Pune through our website, mobile app, or by contacting our 24×7 customer support team for instant assistance.',
  },
  {
    question: 'What types of cabs are available for outstation trips from Pune?',
    answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers, suitable for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for outstation trips from Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with outstation routes from Pune, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book an outstation cab for sightseeing during my trip?',
    answer: 'Of course! Sai Trupti Cabs allows stops for sightseeing, temple visits, and other attractions en route on your outstation trip from Pune.',
  },
  {
    question: 'Is the outstation cab service available 24×7 from Pune?',
    answer: 'Yes, our outstation cab service from Pune operates 24×7 so you can plan and book your trip at any time.',
  },
  {
    question: 'What are the fares for outstation cabs from Pune?',
    answer: 'Our fares depend on the vehicle type and distance. For example, sedans start from ₹2,000, SUVs from ₹2,800–₹3,500, and tempo travellers are priced according to the group size and route.',
  },
  {
    question: 'What payment options are available for outstation cab bookings from Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a secure and convenient transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for outstation cabs?',
    answer: 'All cabs are sanitized before every ride, and our drivers adhere to strict safety and hygiene protocols for a worry-free journey.',
  },
  {
    question: 'Is customer support available during the outstation cab journey from Pune?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your outstation trip from Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Booked an outstation cab from Pune with Sai Trupti Cabs and had a comfortable, hassle-free journey. The driver was professional and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshmukh',
    feedback: 'Excellent service for Pune outstation travel. On-time pickup, clean vehicle, and a very friendly driver made our trip memorable.',
    rating: 5,
  },
];































































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Outstation Cab Booking Pune",
  "image": "https://saitrupticabs.com/assets/images/outstation-cab-pune.jpg", // Replace with actual image URL
  "description": "Book outstation cabs from Pune with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, or weddings. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000", // Example price, adjust according to actual rates
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/outstation-cab-booking-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>Outstation Cab Booking Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book outstation cabs from Pune with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, or weddings. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Outstation Cab Booking Pune, Pune Outstation Cab Booking, Outstation Taxi Booking Pune, Outstation Car Hire Pune, AC Outstation Cab Pune, Non AC Outstation Cab Pune, Luxury Outstation Cab Pune, Innova Outstation Cab Pune, Ertiga Outstation Cab Pune, Affordable Outstation Cab Pune, Pune One Way Outstation Cab, Pune Drop Outstation Cab, Corporate Outstation Cab Pune, Wedding Outstation Cab Pune, Best Outstation Cab Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabbookingpune;